export default function CtaBanner() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20flat%20lay%20of%20curated%20fashion%20lifestyle%20items%20on%20light%20warm%20concrete%20surface%20including%20premium%20sneakers%20leather%20backpack%20sunglasses%20and%20soft%20knit%20scarf%20arranged%20horizontally%2C%20warm%20natural%20window%20lighting%20from%20left%2C%20editorial%20product%20photography%2C%20clean%20modern%20aesthetic%2C%20warm%20neutral%20tones%2C%20soft%20gentle%20shadows%2C%20aspirational%20sophisticated%20composition%2C%20ample%20negative%20space&width=1800&height=600&seq=cta-banner-vigorbuy-v3&orientation=landscape"
          alt="Start exploring the Vigorbuy Spreadsheet today"
          title="Vigorbuy Spreadsheet - Start Shopping Today"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-foreground-950/55"></div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-10 text-center">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-background-50 font-heading mb-5 tracking-tight">
          Start Exploring the Vigorbuy Spreadsheet Today
        </h2>
        <p className="text-base md:text-lg text-background-50/80 max-w-xl mx-auto mb-8">
          Join thousands of smart shoppers who use the Vigorbuy Spreadsheet to discover
          the best products, compare prices, and shop with confidence.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-200 hover:scale-[1.02]"
          >
            Explore Spreadsheet
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 font-semibold rounded-lg text-sm border border-background-50/30 whitespace-nowrap cursor-pointer hover:bg-background-50/25 transition-all duration-200 hover:scale-[1.02]"
          >
            Vigorbuy Sheet
            <i className="ri-external-link-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}